import axios from "axios";

// Detectar automáticamente la URL del backend basándose en el dominio actual
// Esto asegura que siempre se use el dominio correcto en cualquier entorno
const getBackendUrl = () => {
  // Si estamos en el navegador, usar el dominio actual
  if (typeof window !== 'undefined') {
    // En cualquier entorno web (preview, producción, custom domain), usar el dominio actual
    return window.location.origin;
  }
  // Fallback a la variable de entorno (para desarrollo local o SSR)
  return process.env.REACT_APP_BACKEND_URL || '';
};

const BACKEND_URL = getBackendUrl();

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Exportar la función para obtener la URL del backend (para uso en otros componentes)
export { getBackendUrl, BACKEND_URL };

// Helper para obtener URL completa de uploads (para logos, etc.)
export const getUploadUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Prefix with /api for proper routing through Kubernetes ingress
  if (path.startsWith('/uploads')) {
    return `${BACKEND_URL}/api${path}`;
  }
  return `${BACKEND_URL}${path}`;
};

export default api;
